import React from 'react'

const Timer = ({ color, width, height, strokeWidth, fill, className }) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="10"
        x2="14"
        y1="2"
        y2="2"
        stroke={color || 'currentColor'}
        strokeWidth={strokeWidth || '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="12"
        x2="15"
        y1="14"
        y2="11"
        stroke={color || 'currentColor'}
        strokeWidth={strokeWidth || '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="14"
        r="8"
        stroke={color || 'currentColor'}
        strokeWidth={strokeWidth || '2'}
        fill="none"
      />
    </svg>
  )
}

export default Timer
